import { createMuiTheme } from "@material-ui/core/styles";
import { invert } from 'lodash';

export const mainTheme = createMuiTheme({ palette: { primary: { 500: '#749474' } } })
export const pattern = /\{{(.*?)\}}/g

export const isString = (x = '') => Object.prototype.toString.call(x) === '[object String]';
export const isEmptyString = (x = '') => isString(x) && x.length === 0;
export const isNonEmptyString = (x = '') => isString(x) && x.length > 0;
export const isArray = (x) => Array.isArray(x) && x.length > 0;
export const availableLanguageMappings = {
  'English': 'en',
  'German': 'de',
  'Italian': 'it',
  'Norwegian': 'no'
}

export const availableLanguageMappingsInverted = invert(availableLanguageMappings)
export const languages = Object.keys(availableLanguageMappingsInverted)
console.log(languages)
export const placeholder_questions = {
  question_en: "",
  question_it: "",
  question_de: "",
};
